"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.process = void 0;
var processor_1 = require("./processor");
Object.defineProperty(exports, "process", { enumerable: true, get: function () { return processor_1.process; } });
var creator_1 = require("./creator");
Object.defineProperty(exports, "create", { enumerable: true, get: function () { return creator_1.create; } });
//# sourceMappingURL=index.js.map